import S, { DataSignal } from 's-js';
import TZDate from 'lib/TZDate';

import { ScheduleDate as ServerScheduleDate, ScheduleDateData, ScheduleDateOptions } from 'server/models/ScheduleDate';

export { ScheduleDateData, ScheduleDateOptions } from 'server/models/ScheduleDate';

export class ScheduleDate extends ServerScheduleDate {
    Effective: DataSignal<TZDate>;

    constructor();
    constructor(data : ScheduleDateOptions);
    constructor(data : ScheduleDateOptions | null = null) {
        super(data || {});
        this.Effective = EffectiveDate(this);
    }
}

// create a computed Effective data signal with a function that proxies to the ScheduleDate'S Estimated and Actual times
export function EffectiveDate(sched : ScheduleDate) : DataSignal<TZDate> {
    return function (v? : TZDate) : TZDate  {
        return arguments.length === 0 ? sched.Actual() || sched.Estimated() :
            S.sample(sched.Actual)    ? sched.Actual(v!)! : // '!' is safe, as call signatures of DataSignal insure that if we have an argument, it's a TZDate
            sched.Estimated(v!);
    }
}


// WEBPACK FOOTER //
// ./data/models/ScheduleDate.ts